import { CreateWidgetFromFirebaseNode } from '../components/v3/lib/vue-dom-obj'
import { VDomCommands } from './VDomCommand'
import { FBVNodeComponent, VueGridStackComponent } from '../../../types'

export class RemoveCommand extends VDomCommands {
  protected _gridItemVNodeId: string
  protected _widget: object

  constructor(
    gridContainerVNodeId: string,
    GridItemVNodeId: string,
    currentFBNode: object,
  ) {
    super(gridContainerVNodeId)
    this._gridItemVNodeId = GridItemVNodeId
    this._widget = CreateWidgetFromFirebaseNode(currentFBNode)
  }

  getVueComponent(): VueGridStackComponent {
    const _vNodeIdVueComponent_ =
      super.getVueComponent() as VueGridStackComponent
    if (!_vNodeIdVueComponent_.getGrid) {
      // Element must be a gridstack element [GridContainer or SubGridContainer]
      throw 'Invalid Element Found'
    }
    return _vNodeIdVueComponent_
  }

  get$emitData() {
    return { name: 'RemoveCommand', forceBuild: false }
  }

  get firebaseRef() {
    return this.getVueComponent().firebaseRef()
  }

  get $children() {
    return this.getVueComponent().$children
  }

  get $nextTick() {
    return this.getVueComponent().$nextTick
  }

  get hasChanges() {
    return this._widget !== null
  }

  async execute() {
    const wrapComponent = this.getVueComponentByAttr(
      this._gridItemVNodeId,
      false,
    )
    if (wrapComponent) {
      // save to database
      await this.firebaseRef.removeNode(
        +wrapComponent.fbNode.data.props['.key'],
      )
      this.getVueComponent().getGrid().removeWidget(wrapComponent.$el)
    }
  }

  async unExecute() {
    this.firebaseRef.push(this._widget).then(() => {
      this.$nextTick(() => {
        const wrapComponent = this.getVueComponentByAttr(
          this._gridItemVNodeId,
        ) as FBVNodeComponent
        this.getVueComponent().makeWidget(wrapComponent.$el)
        wrapComponent.$el.scrollIntoView({
          behavior: 'smooth',
        })
        if (wrapComponent.resize) {
          wrapComponent.resize()
        }
      })
    })
  }
}

export class RemoveContainerCommand extends RemoveCommand {
  constructor(
    gridContainerVNodeId: string,
    GridItemVNodeId: string,
    currentFBNode: object,
  ) {
    super(gridContainerVNodeId)
    this._gridItemVNodeId = GridItemVNodeId
    this._widget = CreateWidgetFromFirebaseNode(currentFBNode)
  }

  getVueComponent(): VueGridStackComponent {
    if (!this._vNodeIdVueComponent_) {
      this._vNodeIdVueComponent_ = this.getVueComponentById(this._vNodeId, true)
    }
    return this._vNodeIdVueComponent_ as VueGridStackComponent
  }

  get$emitData() {
    return { name: 'RemoveContainerCommand', forceBuild: false }
  }

  async execute() {
    const wrapComponent = this.getVueComponentByAttr(
      this._gridItemVNodeId,
      false,
    )
    if (wrapComponent) {
      // save to database
      this.firebaseRef
        .removeNode(+wrapComponent.fbNode.data.props['.key'])
        .then(() => {
          this.$nextTick(() => {
            this.getVueComponent()?.resizeContainerHeight()
          })
        })
    }
  }

  async unExecute() {
    this.firebaseRef.push(this._widget).then(() => {
      this.$nextTick(() => {
        this.getVueComponent()?.resizeContainerHeight()
      })
    })
  }
}
